import React, { useEffect, useState } from "react";
import { toast } from "sonner";
import { copyText } from "../../../lib/clipboard";
import { Copy, Eye, EyeOff, KeyRound, Loader2, RotateCcw } from "lucide-react";
import { api, errMsg } from "../../../lib/api";

const Field = ({ label, value, secret, testid }) => {
  const [show, setShow] = useState(false);
  return (
    <div className="flex items-center gap-2 h-9 px-3 rounded-lg bg-slate-50 border border-slate-200">
      <span className="text-[10px] font-mono uppercase text-slate-500 w-16">{label}</span>
      <span className="flex-1 truncate font-mono text-xs text-slate-900" data-testid={testid}>{secret && !show ? "•".repeat(12) : value}</span>
      {secret && <button onClick={() => setShow(!show)} aria-label="Show password" data-testid={`${testid}-reveal`} className="text-slate-500 hover:text-slate-900">{show ? <EyeOff size={13} /> : <Eye size={13} />}</button>}
      <button onClick={() => copyText(value, `${label} copied`)} aria-label={`Copy ${label}`} data-testid={`${testid}-copy`} className="text-slate-500 hover:text-slate-900"><Copy size={13} /></button>
    </div>
  );
};

export const AdminCard = ({ projectId }) => {
  const [admin, setAdmin] = useState(null);
  const [busy, setBusy] = useState(false);
  useEffect(() => { api.dbAdmin(projectId).then(setAdmin).catch(() => setAdmin(null)); }, [projectId]);

  const reset = async () => {
    setBusy(true);
    try { setAdmin(await api.dbAdminReset(projectId)); toast.success("New admin password created"); } catch (e) { toast.error(errMsg(e)); } finally { setBusy(false); }
  };

  return (
    <div className="rounded-xl border border-indigo-200 bg-indigo-50 p-4 space-y-3" data-testid="db-admin-card">
      <div className="flex items-center gap-2">
        <KeyRound size={15} className="text-indigo-600" />
        <h4 className="text-sm font-semibold text-slate-900">Your app's admin login</h4>
        <button onClick={reset} disabled={busy || !admin} data-testid="db-admin-reset-btn" className="ml-auto h-7 px-2.5 rounded-md border border-slate-300 text-xs text-slate-600 hover:text-slate-900 flex items-center gap-1.5 disabled:opacity-50">
          {busy ? <Loader2 size={12} className="animate-spin" /> : <RotateCcw size={12} />} New password
        </button>
      </div>
      <p className="text-xs text-slate-500">Sign in with this inside your app to see and manage everyone's data. Only you can see it here.</p>
      {admin ? (
        <div className="grid sm:grid-cols-2 gap-2">
          <Field label="Email" value={admin.email} testid="db-admin-email" />
          <Field label="Password" value={admin.password} secret testid="db-admin-password" />
        </div>
      ) : <div className="h-9 rounded-lg shimmer border border-slate-200" />}
    </div>
  );
};

export default AdminCard;
